import { Capacitor } from "@capacitor/core";
import { Preferences } from '@capacitor/preferences';

export const JwtService = {
  async setCredential(email, password){
    const platform = Capacitor.getPlatform();
    if(platform === 'ios' || platform === 'android') {
      await Preferences.set({
        key: 'email',
        value: email,
      });
      await Preferences.set({
        key: 'password',
        value: password,
      });
    }
  },

  async getCredential() {
    try{
      const { value: email } = await Preferences.get({ key: 'email' });
      const { value: password } = await Preferences.get({ key: 'password' });
      return {
        email: email || '',
        password: password || ''
      }
    }catch(err){
      return {
        email: '',
        password: ''
      }
    }
  }
};
